import React, { useState } from "react";
import { Box, Container, ImageList, ImageListItem, Typography } from "@mui/material";
import { ImageLightboxModal } from "./ImageLightboxModal";

export const Instalaciones = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const itemData = [
    { img: '/place/202609_1.webp', alt: 'Cabina privada de masaje oriental en Barcelona Eixample' },
    { img: '/place/202609_2.webp', alt: 'Sala de masajes relajantes y aromaterapia en ambiente cálido' },
    { img: '/place/202609_3.webp', alt: 'Espacio acondicionado con luz tenue para máxima relajación y bienestar' },
    { img: '/place/202609_4.webp', alt: 'Cabina individual equipada para masajes descontracturantes en Barcelona' },
    { img: '/place/202609_5.webp', alt: 'Tatami oriental tradicional para terapias y masajes auténticos' },
    { img: '/place/202609_6.webp', alt: 'Sala de tratamiento confortable con ropa de camilla higienizada' },
  ];

  const handleOpen = (index: number) => {
    setSelectedIndex(index);
    setOpenModal(true);
  };

  return (
    <Box
      component="section"
      id="instalaciones"
      sx={{
        backgroundColor: "#FAF8F5",
        py: { xs: 5, md: 7 },
      }}
    >
      <Container>
        <Box sx={{ maxWidth: "760px", mx: "auto", textAlign: "center", mb: 4.5 }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.6,
              borderRadius: "30px",
              backgroundColor: "rgba(212, 175, 55, 0.1)",
              border: "1px solid rgba(212, 175, 55, 0.25)",
              color: "#9E7736",
              fontSize: "0.75rem",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              mb: 2,
            }}
          >
            <span>✦</span> Espacios de Serenidad
          </Box>
          <Typography
            variant="h2"
            sx={{
              mb: 1.5,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              color: "#1C1612",
              fontWeight: 700,
              fontSize: { xs: "1.85rem", md: "2.35rem" },
              letterSpacing: "-0.02em",
            }}
          >
            Nuestras Instalaciones
          </Typography>
          <Typography variant="body1" sx={{ color: "#68594F", fontSize: "0.95rem", lineHeight: 1.7 }}>
            Sumérgete en la elegancia de nuestros espacios, diseñados para ofrecerte un ambiente íntimo, sereno y confortable.
          </Typography>
        </Box>

        <ImageList
          variant="masonry"
          sx={{
            columnCount: {
              xs: '2 !important',
              sm: '2 !important',
              md: '3 !important',
              lg: '4 !important',
            },
            gap: 16,
          }}
        >
          {itemData.map((item, index) => (
            <ImageListItem
              key={item.img}
              onClick={() => handleOpen(index)}
              sx={{
                overflow: "hidden",
                borderRadius: "16px",
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px) scale(1.02)",
                  "& img": {
                    boxShadow: "0 12px 24px rgba(160, 122, 52, 0.2)",
                  },
                },
              }}
            >
              <img
                src={item.img}
                alt={item.alt}
                style={{
                  borderRadius: "16px",
                  border: "1px solid #EEDFC6",
                  boxShadow: "0 4px 14px rgba(160, 122, 52, 0.08)",
                  display: "block",
                  width: "100%",
                  transition: "box-shadow 0.3s ease",
                }}
                loading="lazy"
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Container>

      <ImageLightboxModal
        open={openModal}
        currentIndex={selectedIndex}
        items={itemData}
        onClose={() => setOpenModal(false)}
        onNavigate={(newIndex) => setSelectedIndex(newIndex)}
      />
    </Box>
  );
};